(function ($) {

  if( $(".fmp-cc-page") ) {

    //CC Add product
    $(".fmp-cc-page").on("click", "input[name=fmp-cc-service]", function (e) {
      fmpAddCareerCoaching();
    });

    $(".fmp-cc-page").on("click", ".fmp-cc-btn", function (e) {
      e.preventDefault();

      var ccService = $(this).attr('data-id');
      $(".fmp-" + ccService).prop("checked", true);
      $("html, body").animate(
        {
          scrollTop: $(".fmp-cc-services-table").offset().top,
        },
        300
      );

      fmpAddCareerCoaching();
    });

    //CC Remove product
    $(".fmp-cc-page").on("click", ".fmp-cc-remove", function (e) {
      e.preventDefault();

      var dataId = $(this).parent(".fmp-cc-item").attr("data-id");

      $(".fmp-" + dataId).prop("checked", false);

      var addProduct = JSON.parse(sessionStorage.getItem("fmp_add_cc"));
      addProduct = addProduct.filter(function (el) {
        return dataId.indexOf(el.id) < 0;
      });
      sessionStorage.setItem("fmp_add_cc", JSON.stringify(addProduct));

      var data = {
        action: "fmp_remove_cc",
        nounce: localized.ajaxnonce,
        remove_product: dataId,
        add_product: addProduct,
      };

      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          var total = response.total;

          $(".fmp-cart-block__total .fmp-total-price").html(
            response.currentSymbol + total
          );
          $(".fmp-afterpay .fmp-total-price").html(
            response.currentSymbol + response.afterpay
          );
          $(".fmp-cc-total span").html(
            "Proceed to Checkout (" + response.currentSymbol + total + ")"
          );
        },
      });

      if ($(".fmp-cart-block__items .fmp-cc-item").length == 1) {
        $(".fmp-cart-block .fmp-cart-block-empty").show();
        $(".fmp-cart-block .fmp-cart-detail").html('');
      }

      $(".fmp-cart-block__items")
        .find("[data-id='" + dataId + "']")
        .removeClass("fmp-cc-item")
        .fadeOut(300);
    });

     // CC page redirect to checkout
     $(".fmp-cc-page").on("click", ".fmp-cc-total", function (e) {
      e.preventDefault();
      var products = JSON.parse(sessionStorage.getItem("fmp_add_cc"));
      fmpCCAddToCart(products);
    });
  }

  function fmpAddCareerCoaching() {
    var selectedServices = [];

    $(".fmp-cc-services-table input:checkbox[name=fmp-cc-service]:checked").each(function () {
      var value = $(this).val();
      data = { id: value, quantity: "1" };
      selectedServices.push(data);
    });

    if (selectedServices.length === 0) {
      $(".fmp-cart-block .fmp-cart-block-empty").show();
      $(".fmp-cart-block .fmp-cart-detail").html('');

    } else {
      $(".fmp-cart-block .fmp-cart-block-empty").hide();

      $(".fmp-cart-block .fmp-cart-detail").html(
        '<div class="fmp-content-preloader"><div class="preloader-spinner"></div></div>'
      );
      var data = {
        action: "fmp_add_cc",
        nounce: localized.ajaxnonce,
        selected_cc: selectedServices,
      };
      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          sessionStorage.setItem(
            "fmp_add_cc",
            JSON.stringify(response.products)
          );
          $(".fmp-cart-block .fmp-cart-detail").html(response.output);
        },
      });
    }
  }

  function fmpCCAddToCart(products) {
    $.ajax({
      url: localized.ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "fmp_cc_add_to_cart",
        items: products,
        nounce: localized.ajaxnonce,
      },
      success: function (response) {
        var redirect = $(".fmp-cc-total").attr("href");
        window.location.href = redirect;
      },
    });
  }

})(jQuery);

const teamSection = document.querySelector('.fmp-cc-team');

if (teamSection) {

  const resizeImage = () => {
      const members = document.querySelectorAll('.fmp-cc-team__list-item');

      members.forEach(function (member, i) {
        const contentHeight = member.querySelector('.fmp-cc-team__content').offsetHeight;
        const image = member.querySelector('.fmp-cc-team__avatar');

        if (window.innerWidth > 767) {
          image.setAttribute('style', `height:${contentHeight}px`);
        } else {
          image.setAttribute('style', `height:auto`);
        }
      });
  }

  resizeImage();

  window.onresize = resizeImage;
} 
